import { render, staticRenderFns } from "./LocationBunttonBottom.vue?vue&type=template&id=f22f7aac&scoped=true"
import script from "./LocationBunttonBottom.vue?vue&type=script&lang=js"
export * from "./LocationBunttonBottom.vue?vue&type=script&lang=js"
import style0 from "./LocationBunttonBottom.vue?vue&type=style&index=0&id=f22f7aac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22f7aac",
  null
  
)

export default component.exports